import { Link } from '@tanstack/react-router'
import { Typography, Button, Box, Container } from '@mui/material'

/**
 * The marketing-site footer. Shared with /docs for the same reason as SiteNav:
 * the docs section should be indistinguishable from the rest of the site.
 */
export function SiteFooter() {
  return (
    <Box sx={{ borderTop: '1px solid var(--border-soft)', py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 2,
        }}>
          <Typography variant="caption" sx={{ color: 'var(--text-faint)' }}>
            © {new Date().getFullYear()} FolioWorth — built in Toronto
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button component={Link} to="/docs" size="small" color="inherit">Docs</Button>
            <Button component={Link} to="/pricing" size="small" color="inherit">Pricing</Button>
            <Button component={Link} to="/api-docs" size="small" color="inherit">API</Button>
            <Button component={Link} to="/login" size="small" color="inherit">Sign in</Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}
